module.exports = __webpack_public_path__ + "static/media/petmatchlogo.be8ac5a2.png";